import { Options } from "@hey-api/client-fetch";
import {
  PostV1OrganizationsByOrganizationIdProfilesData,
  PostV1OrganizationsByOrganizationIdProfilesError,
  PostV1OrganizationsByOrganizationIdProfilesResponse,
  PostV2OrganizationsByOrganizationIdProfilesData,
  PostV2OrganizationsByOrganizationIdProfilesError,
  PostV2OrganizationsByOrganizationIdProfilesResponse,
} from "../../client";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import {
  postV1OrganizationsByOrganizationIdProfilesMutation,
  postV2OrganizationsByOrganizationIdProfilesMutation,
} from "../../client/@tanstack/react-query.gen";
import { getOrganizationOptions } from "./get-organization";
import { organizationProfilesQueryOptions } from "./get-organization-profiles";

const mutationKey = ["addOrganizationMember"];

export const useAddOrganizationProfile = (
  options: UseMutationOptions<
    PostV1OrganizationsByOrganizationIdProfilesResponse,
    PostV1OrganizationsByOrganizationIdProfilesError,
    Options<PostV1OrganizationsByOrganizationIdProfilesData>
  > = {},
  profileId?: string,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...postV1OrganizationsByOrganizationIdProfilesMutation(),
    mutationKey,
    ...options,
    onSuccess: (memberResponseBody, vars, context) => {
      options?.onSuccess?.(memberResponseBody, vars, context);
    },
    onSettled: (data, error, vars, context) => {
      queryClient.invalidateQueries({ queryKey: getOrganizationOptions(vars.path.organizationID).queryKey });
      queryClient.invalidateQueries({ queryKey: organizationProfilesQueryOptions(vars.path.organizationID).queryKey });
      options?.onSettled?.(data, error, vars, context);
    },
  });
};

export const useAddOrganizationProfileV2 = (
  options: UseMutationOptions<
    PostV2OrganizationsByOrganizationIdProfilesResponse,
    PostV2OrganizationsByOrganizationIdProfilesError,
    Options<PostV2OrganizationsByOrganizationIdProfilesData>
  > = {},
) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...postV2OrganizationsByOrganizationIdProfilesMutation(),
    mutationKey,
    ...options,
    onSuccess: (memberResponseBody, vars, context) => {
      options?.onSuccess?.(memberResponseBody, vars, context);
    },
    onSettled: (data, error, vars, context) => {
      queryClient.invalidateQueries({ queryKey: getOrganizationOptions(vars.path.organizationID).queryKey });
      queryClient.invalidateQueries({ queryKey: organizationProfilesQueryOptions(vars.path.organizationID).queryKey });
      options?.onSettled?.(data, error, vars, context);
    },
  });
};
